/**
 * Trigger: tr_accounts_insert
 * Purpose: Create account balances for all currencies when an account is inserted
 * Table: accounts
 * Event: AFTER INSERT
 */
export const TR_ACCOUNTS_INSERT = `
CREATE TRIGGER tr_accounts_insert
AFTER INSERT ON accounts
FOR EACH ROW
BEGIN
  INSERT OR IGNORE INTO account_balances(currency_id, account_id)
  SELECT _id, new._id FROM currencies;
END;
`;
